<section class="panel-center">
  <div class="calendar-header">
    <span class="calendar-header__spacer" aria-hidden="true"></span>
    <div class="calendar-header__nav">
      <button class="nav-btn" click.trigger="calendar.prevMonth()" disabled.bind="calendar.loading || calendar.monthLoading || !calendar.canGoPrev"><span class="icon icon--page-prev" aria-hidden="true"></span></button>
      <select class="month-select" value.bind="calendar.selectedMonthIndex" change.trigger="calendar.jumpToMonth()" disabled.bind="calendar.loading || calendar.monthLoading">
        <option repeat.for="opt of calendar.monthOptions" model.bind="opt.index">${opt.label}</option>
      </select>
      <button class="nav-btn" click.trigger="calendar.nextMonth()" disabled.bind="calendar.loading || calendar.monthLoading || !calendar.canGoNext"><span class="icon icon--page-next" aria-hidden="true"></span></button>
    </div>
    <button class="nav-btn calendar-header__reload" click.trigger="calendar.reloadMonth()" disabled.bind="calendar.loading || calendar.monthLoading" title="Reload this month from the database">
      <span if.bind="calendar.monthLoading" class="spinner-ring" aria-hidden="true"></span>
      <span if.bind="!calendar.monthLoading" class="icon icon--refresh" aria-hidden="true"></span>
    </button>
  </div>
  <div class="calendar-grid-wrap">
    <div class="calendar-loading-overlay" if.bind="calendar.monthLoading" aria-live="polite">
      <span class="calendar-loading-spinner" aria-hidden="true"></span>
      <span class="calendar-loading-text">Loading ${calendar.loadingMonthName}…</span>
    </div>
  <div class="calendar-grid ${calendar.monthLoading ? 'is-loading' : ''}">
    <div class="day-header">Sun</div>
    <div class="day-header">Mon</div>
    <div class="day-header">Tue</div>
    <div class="day-header">Wed</div>
    <div class="day-header">Thu</div>
    <div class="day-header">Fri</div>
    <div class="day-header">Sat</div>

    <div
      repeat.for="day of calendar.calendarDays"
      class="calendar-day ${day.isCurrentMonth ? '' : 'other-month'} ${day.isToday ? 'today' : ''} ${day.releaseCount > 0 ? 'has-releases' : ''} ${calendar.selectedDay === day ? 'selected' : ''}"
      click.trigger="calendar.selectDay(day)">
      <span class="day-number">${day.date}</span>
      <span if.bind="day.releaseCount > 0 && day.isCurrentMonth" class="release-count">${day.releaseCount}</span>
    </div>
  </div>
  </div>

  <admin-log></admin-log>
</section>
